<template>
    <div class="pa-0 ma-0">
        <v-chip :color="propriedadesChip.background" :text-color="propriedadesChip.color" :disabled="true">
            {{ documento.situacao | filtroSituacaoAnaliseCredenciamento}}
            <v-icon size="15" v-if="!existeSolicitacaoReenvioOuReenviado" right>{{propriedadesChip.icon}}</v-icon>
            <v-icon size="15" v-else right @click="mostrarDialogoConfirmacaoReenvio = true">{{propriedadesChip.icon}}</v-icon>
        </v-chip>

        <v-dialog v-model="mostrarDialogoConfirmacaoReenvio" persistent max-width="700">
            <v-card>
                <v-card-title class="primary modal-title" primary-title>
                    Motivo da Solicitação
                </v-card-title>
                <v-card-text>
                    <v-layout>
                        <v-flex xs12>
                            <label><strong>Documento</strong></label>
                            <p class="text--secondary"  v-html="documento.descricao"></p>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-text class="pb-0 az-form-content">
                    <label><strong>Motivo</strong></label>
                    <p class="text--secondary"  v-html="documento.motivoReenvio"></p>
                </v-card-text>
                <v-card-actions class="acoes justify-space-between">
                    <v-btn class="ml-3" color="#777" flat @click="mostrarDialogoConfirmacaoReenvio = false">
                        Voltar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

export default {
  name: 'SituacaoPillFornecedor',
  props: {
      documento: {
          type: Object,
          default: () => {}
      }
  },
    data: () => {
        return {
            situacoes : {
                ANALISADO: {
                    color: '#51a806',
                    background: 'transparent',
                    icon: 'check_circle_outline'
                },
                AGUARDANDO_ENVIO: {
                  color: 'warning',
                  background: 'transparent',
                  icon: 'info_outline'
                },
                AGUARDANDO_REENVIO: {
                    color: 'warning',
                    background: 'transparent',
                    icon: 'info_outline'
                },
                REENVIADO: {
                    color: '#be6100',
                    background: 'transparent',
                    icon: 'check_circle_outline'
                },
                AGUARDANDO_ANALISE: {
                    color: '#1e1d1d',
                    background: 'transparent',
                    icon: 'schedule'
                },
                REENVIADO_TEMPORARIO: {
                    color: '#484747',
                    background: 'transparent',
                    icon: 'cloud_done'
                }
            },
            mostrarDialogoConfirmacaoReenvio: false,
        }
    },
  computed: {
      propriedadesChip(){
          return this.situacoes[this.documento.situacao] || this.situacoes['REENVIADO_TEMPORARIO']
      },

      existeSolicitacaoReenvioOuReenviado(){
          return  ['AGUARDANDO_REENVIO', 'REENVIADO', 'AGUARDANDO_ENVIO'].includes(this.documento.situacao)
      }
  }
};
</script>

<style scoped>

</style>